import ConfirmModal from 'views/components/ConfirmModal'

import useRemoveUserHandler from '../../../effects/remove-user-from-group'
import { Group, GroupQuery } from '../../../../../../../graphql'
import { heapEvent } from '@equipmentshare/heaper'

export type RemoveUserModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
	onConfirm: () => void,
	group: Group,
	user: GroupQuery['group']['users'][number],
}

export default function RemoveUserModal( { onCancel, onSuccess, group, user, onConfirm }: RemoveUserModalProps ) {
	const removeUser = useRemoveUserHandler()

	const handleSubmit = async() => {
		heapEvent( 'Inventory - Remove User From Group Modal - Click - Remove', {} )
		const result = await removeUser( group, parseInt( user.id, 10 ) )
		onConfirm()
		return result
	}

	const handleCancel = () => {
		heapEvent( 'Inventory - Remove User From Group Modal - Click - Cancel', {} )
		onCancel()
	}

	return (
		<ConfirmModal
			message={`You are about to remove ${user.firstName} ${user.lastName} from ${group.name}. Do you want to proceed?`}
			onConfirm={async() => await handleSubmit()}
			buttonColor="danger"
			buttonText="Remove"
			onCancel={handleCancel}
			onSuccess={onSuccess}
		/>
	)
}
